import React from "react";
import { useDispatch, useSelector } from "react-redux";
import NavigationDrawer from "../../../components/NavigationDrawer";
import MobileView from "./MobileView";

function ClientMarketPlace() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);

  return (
    <NavigationDrawer>
      <MobileView />
    </NavigationDrawer>
  );
}

export default ClientMarketPlace;
